import { MediaHelpers } from '@wajeez-web/core/api';
import React from 'react';

import {
  BaseComponentProps,
  useComponentData,
} from '../../helpers/contentHooks';
import { ClickableComponentLayout } from '../../layouts/ClickableComponentLayout';

export interface HorizontalListItemParameters {
  image: string | null;
}

interface HorizontalListItemProps extends BaseComponentProps {
  onClick?: () => void;
}

export const HorizontalListItem = React.forwardRef<
  HTMLDivElement,
  HorizontalListItemProps
>(({ component, context, isLastSibling, extraProps, onClick }, ref) => {
  const { getParameterValue, content, isLockedContent } =
    useComponentData<HorizontalListItemParameters>(component, context);

  const image = getParameterValue('image');

  return (
    <ClickableComponentLayout content={content} onClickExtra={onClick}>
      <div
        ref={ref}
        className={`w-full py-4 sm:py-0 flex sm:flex-col items-start justify-start ${
          !isLastSibling && 'border-b-[0.5px]'
        } border-[#C6C6C8] dark:border-dark-divider dark:border-dark-divider sm:border-none`}
      >
        <div
          style={{
            backgroundImage:
              'url(' + MediaHelpers.getPublicMediaById(image) + ')',
          }}
          className={`relative h-[94px] sm:h-[150px] w-[94px] sm:w-auto min-w-[94px] sm:min-w-[150px] border sm:border-none bg-cover bg-center bg-no-repeat rounded-[10px]`}
        >
          {isLockedContent && content?.contentEntityType !== 'FICTION' && (
            <div className="w-[25px] h-[25px] absolute bottom-[10px] left-[10px]">
              <img
                src="../../assets/images/lock.png"
                alt="lock"
                className="block w-full h-full"
              />
            </div>
          )}
        </div>
        <div className="sm:max-w-[150px] self-stretch ps-2 sm:pe-2 sm:px-0 sm:pt-2 flex flex-col justify-center items-start">
          <div className="text-[15px] font-medium sm:font-bold sm:text-[#545454]">
            {content?.title}
          </div>
          <div className="text-[12px] sm:text-[15px] sm:font-medium mt-[3px] text-[rgba(60,_60,_67,_0.6)] dark:text-dark-light sm:text-[#545454]">
            {content?.authors?.toString().replaceAll(',', ' و ')}
          </div>
          <div
            className="w-fit text-[12px] mt-[3px] px-2 py-1 rounded-[5px] dark:text-black"
            style={{ backgroundColor: extraProps?.['color'] }}
          >
            {extraProps?.['displayName']}
          </div>
        </div>
      </div>
    </ClickableComponentLayout>
  );
});
